import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { useFormFlow, useSetScreen } from '@/components/form-flow'
import { GoalSettingIntro } from '@/features/goal-setting/GoalSettingIntro'
import { SettingFinancialGoals } from '@/features/goal-setting/SettingFinancialGoals'
import { Breadcrumb, Icon } from '@/ui'

export enum GOAL_SETTING_SCREENS {
  intro = 'intro',
  setGoals = 'setGoals',
}

export const GoalSetting = () => {
  const navigate = useNavigate()
  const backLink = '/'
  const { setScreen, currentScreen } = useSetScreen({
    backLink,
  })

  const screenConfig = useMemo(() => {
    const props = { goBack: setScreen }
    return [
      {
        component: () => (
          <GoalSettingIntro
            {...props}
            goToNextStep={() => setScreen(GOAL_SETTING_SCREENS.setGoals)}
          />
        ),
        screenName: GOAL_SETTING_SCREENS.intro,
        step: 0,
      },
      {
        component: () => <SettingFinancialGoals {...props} />,
        screenName: GOAL_SETTING_SCREENS.setGoals,
        step: 1,
      },
    ]
  }, [setScreen])

  useEffect(() => {
    if (!currentScreen) {
      setScreen(GOAL_SETTING_SCREENS.intro, true)
    }
  }, [setScreen, currentScreen])

  const { content } = useFormFlow({
    steps: [],
    screens: screenConfig,
  })

  return (
    <>
      <Breadcrumb>
        <Breadcrumb.List>
          <Breadcrumb.Item>
            <Breadcrumb.Link onClick={() => navigate('/')}>
              <Icon icon={faArrowLeft} />
              Back to Home
            </Breadcrumb.Link>
          </Breadcrumb.Item>
        </Breadcrumb.List>
      </Breadcrumb>
      {content}
    </>
  )
}
